import { Calendar, Filter, Search, Pill, Download, FileText } from "lucide-react"

export default function PrescriptionDetails() {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title">
          <FileText />
          <h1>Prescriptions</h1>
        </div>
      </div>

      <div className="search-container">
        <div className="search-input">
          <Search className="search-icon" />
          <input type="text" placeholder="Search prescriptions..." />
        </div>
        <div className="filter-group">
          <button className="filter-button">
            <Filter />
            <span>Filter by Hospital</span>
          </button>
          <button className="filter-button">
            <Calendar />
            <span>Filter by Date</span>
          </button>
        </div>
      </div>

      <div className="prescription-cards">
        <div className="prescription-card">
          <h3>Antibiotics Course</h3>
          <p className="prescription-date">Prescribed on 10/10/2023</p>

          <div className="prescription-details">
            <div className="detail-item">
              <Pill />
              <span>Medications: 2</span>
            </div>
          </div>

          <div className="prescription-footer">
            <p className="doctor-name">Dr. James Wilson</p>
            <Download className="download-icon" />
          </div>
        </div>

        <div className="prescription-card">
          <h3>Pain Management</h3>
          <p className="prescription-date">Prescribed on 9/5/2023</p>

          <div className="prescription-details">
            <div className="detail-item">
              <Pill />
              <span>Medications: 1</span>
            </div>
          </div>

          <div className="prescription-footer">
            <p className="doctor-name">Dr. Emily Rodriguez</p>
            <Download className="download-icon" />
          </div>
        </div>

        <div className="prescription-card">
          <h3>Hypertension Medication</h3>
          <p className="prescription-date">Prescribed on 10/1/2023</p>

          <div className="prescription-details">
            <div className="detail-item">
              <Pill />
              <span>Medications: 1</span>
            </div>
          </div>

          <div className="prescription-footer">
            <p className="doctor-name">Dr. Sarah Johnson</p>
            <Download className="download-icon" />
          </div>
        </div>

        <div className="prescription-card">
          <h3>Allergy Relief</h3>
          <p className="prescription-date">Prescribed on 9/15/2023</p>

          <div className="prescription-details">
            <div className="detail-item">
              <Pill />
              <span>Medications: 2</span>
            </div>
          </div>

          <div className="prescription-footer">
            <p className="doctor-name">Dr. Michael Chen</p>
            <Download className="download-icon" />
          </div>
        </div>
      </div>
    </div>
  )
}

